/*global window, _, MOVE_DATA, google, localStorage, JST */
import { Message } from "./components/message";

import { loadMaps, onMapLoad } from "maps";

//This places the map controls to the top right corner of each map.
export const getMapOptions = function () {
  return {
    zoomControlOptions: {
      style: window.google.maps.ZoomControlStyle.SMALL,
      position: window.google.maps.ControlPosition.TOP_RIGHT
    },
    mapTypeControlOptions: {
      position: window.google.maps.ControlPosition.TOP_RIGHT,
      style: window.google.maps.MapTypeControlStyle.DEFAULT,
      mapTypeIds: [
        window.google.maps.MapTypeId.ROADMAP,
        window.google.maps.MapTypeId.SATELLITE,
        window.google.maps.MapTypeId.HYBRID
      ]
    }
  };
};

export const triggerOnDrag = function($container) {
  var drag = 0,
      _touchEvents = { start: 'touchstart.map', move: 'touchmove.map', end: 'touchend.map'},
      _mouseEvents = { start: 'mousedown.map', move: 'mousemove.map', end: 'mouseup.map'},
      // our maps do not support touch dragging on desktops with touchscreens
      events = MOVE.Helper.isMobileDevice() ? _touchEvents : _mouseEvents;

  _.each(events, function(event) { $container.off(event); });

  $container
    .on(events.start, () => drag = 0)
    .on(events.move, () => drag++)
    .on(events.end, (e) => {
      $container.trigger({
        type: "drag.map",
        target: e.target,
        drag: drag,
        endEvent: e
      });

      drag = 0;
    });

  return $container;
};

const elementFromEvent = ({event}) => {
  // idea: use elementFromPoint if has coordinates
  // otherwise use target
  if (event.clientX && event.clientY)
    return document.elementFromPoint(event.clientX, event.clientY);
  else
    return event.target;
};

export const bindInfoWindowCloseEvents = function($container, callback){
  triggerOnDrag($container).on("drag.map", function(e) {
    const $element = $(elementFromEvent({event: e.endEvent})),
          drag = e.drag;
    // the condition is less than 10
    // presumably we want to include small but exclude large drags
    // addresses scenario where jquery event.target does not provide
    // topmost element clicked
    if (drag <= 10 &&
        !$element.hasClass('map-property-pin') &&
        !$element.parent().hasClass('map-property-pin')) {
      callback(e);
    }
  });
};

// Check if radius search is on currently
export const isRadiusSearch = function () {
  return _.has(MOVE.SRP, 'SearchFacet') &&
    MOVE.SRP.SearchFacet.isRadiusSet();
};

export const mapEnvironment = function(config) {
  return config.google_maps_environment !== undefined ? (config.google_maps_environment + "-") : "";
};

/*
  Initializes the Map Component.
  - Accepts a callback function and a forceCallback boolean
*/
export const initMapComponent = function(callback, forceCallback) {
  var config = MOVE.DataStore.getData('mapConfiguration'),
      clientId = 'rdcV8',
      toolsVersion = '1.0.4',
      scriptsLoaded = function scriptsLoaded() {
        if (callback && (typeof(callback) === 'function')) {
          callback({ config: config, clientId: clientId, toolsVersion: toolsVersion });
        }
      };

  if (config) {
    onMapLoad(scriptsLoaded);
    loadMaps("rdc-ldp-amenities");
  }

  if (forceCallback) {
    scriptsLoaded();
  }
};

// LatLngBounds bnds -> height and width as a Point
export const getSizeInPixels = function (projection, bounds) {
  var sw = projection.fromLatLngToContainerPixel(bounds.getSouthWest());
  var ne = projection.fromLatLngToContainerPixel(bounds.getNorthEast());
  return new google.maps.Point(Math.abs(sw.y - ne.y), Math.abs(sw.x - ne.x));
};

//LatLngBounds b1, b2 -> zoom increment
export const getExtraZoom = function(projection, expectedBounds, actualBounds) {
  var expectedSize = getSizeInPixels(projection, expectedBounds),
      actualSize = getSizeInPixels(projection, actualBounds);

  if (Math.floor(expectedSize.x) === 0 || Math.floor(expectedSize.y) === 0) {
    return 0;
  }

  var qx = actualSize.x / expectedSize.x;
  var qy = actualSize.y / expectedSize.y;
  var min = Math.min(qx, qy);

  if (min < 1) {
    return 0;
  }
  return Math.floor(Math.log(min) / Math.log(2) /* = log2(min) */);
};


export const fitMaxBound = function (myMap, bounds) {
  myMap.fitBounds(bounds);
  var overlayHelper = new google.maps.OverlayView({setMap : myMap});
  overlayHelper.draw = function () {
    if (!this.ready) {
      var projection = this.getProjection(),
          zoom = getExtraZoom(projection, bounds, myMap.getBounds());
      setZoomLevel(myMap, zoom);
      this.ready = true;
      google.maps.event.trigger(this, 'ready');
    }
  };
  overlayHelper.setMap(myMap);
};

const setZoomLevel = function(myMap, zoom) {
  if (zoom > 0) {
    myMap.setZoom(myMap.getZoom() + zoom);
  }
  if (MOVE_DATA.pageType === "srp" && MOVE.Helper.getPropertiesCount() === 0) {
    myMap.setZoom(myMap.getZoom() - MOVE.CONSTANTS.GET_NORESULTS_ZOOM);
  }
};

// Create Map Message
export const createMapMessage = function (component, callback) {
  var message = new Message({
    mapContainer: component.options.container
  });
  component.message = message;
  if (callback) {
    callback(component);
  }
};

// Check if radius boundary exist in map cache
export const radiusBoundExist = function(){
  try{
    return MOVE.SRP.MapView.map.areas.cache.data['search-entity'].items.hasOwnProperty(1);
  } catch (err) {
    return false;
  }
};

// Check if radius search in on after page refreshed
export const isRadiusSearchOnPageRefresh = function(){
  return isRadiusSearch() &&
    !radiusBoundExist() &&
    !_.isNull(MOVE_DATA.radius_init_boundary) &&
    !_.isUndefined(MOVE_DATA.radius_init_boundary);
};

MOVE.MapHelper = {
  getMapOptions: getMapOptions,
  radiusBoundExist: radiusBoundExist,
  isRadiusSearchOnPageRefresh: isRadiusSearchOnPageRefresh,
  isRadiusSearch: isRadiusSearch,
  initMapComponent: initMapComponent,
  fitMaxBound: fitMaxBound,
  createMapMessage: createMapMessage,
  triggerOnDrag: triggerOnDrag,
  bindInfoWindowCloseEvents: bindInfoWindowCloseEvents,
  mapEnvironment: mapEnvironment
};



// WEBPACK FOOTER //
// ./shared_critical/map_helper.js